import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import { theme } from "../../../utils/global-styles/theme";

import RightGoToArrow from "../../../components/CourseCard/Icons/RightGoToArrow";
import BulletIcon from "../../../components/shared/BlurredContentContainer/Assets/BulletIcon";

const MobileCourseType = ({
  index,
  margin,
  heading,
  description,
  link,
  benefit1,
  benefit2,
  benefit3,
  image,
  imageTint,
}) => {
  const MobileGrid = styled.div`
      display: none;
      grid-template-rows: 300px 1fr;
      grid-template-columns: 48% 52%;
      font-family: ${theme.fontFaces.headers};
      margin: ${margin};

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        display: grid;
      }

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        grid-template-rows: 200px 1fr;
      }
    `,
    TitleDescriptionLinkContainer = styled.div`
      grid-area: 2 / 1 / span 1 / span 1;
      padding-top: 30px;
      padding-left: 14px;
    `,
    CourseTypeHeading = styled.h2`
      font-size: 20px;
      font-weight: bold;
      letter-spacing: -0.52px;
      line-height: 24px;
      margin-bottom: 14px;
    `,
    CourseTypeDescription = styled.h3`
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.3px;
      line-height: 18px;
      margin-bottom: 17px;
    `,
    CtaLink = styled(Link)`
      font-size: 13px;
      font-weight: bold;
      letter-spacing: -0.28px;
      line-height: 16px;
    `,
    BenefitsListContainer = styled.div`
      grid-area: 2 / 2 / span 1 / span 1;
      padding: 64px 0;
    `,
    ListItemContainer = styled.div`
      display: flex;
      padding-left: 15px;
    `,
    ListItemText = styled.h3`
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -0.2px;
      line-height: 16px;
    `,
    ImgContainer = styled.div`
      grid-area: 1 / 1 / span 1 / span 2;
      overflow: hidden;
    `,
    StyledImg = styled(GatsbyImage)`
      height: 300px;
      width: 100%;

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        height: 200px;
      }
    `;
  return (
    <MobileGrid>
      <TitleDescriptionLinkContainer className="light-bg">
        <CourseTypeHeading>{heading}</CourseTypeHeading>
        <CourseTypeDescription>{description}</CourseTypeDescription>
        <CtaLink to={`${link.url}/`} className="secondary-hover">
          {link.linkText.toUpperCase()}
          &nbsp; &nbsp;
          <RightGoToArrow
            width="20px"
            height="11.43px"
            fillColor="main-fill"
          />
        </CtaLink>
      </TitleDescriptionLinkContainer>
      <BenefitsListContainer className="light-bg">
        <ListItemContainer
          css={css`
            margin-bottom: 20px;
          `}
        >
          <BulletIcon height="13px" width="13px" />
          &nbsp;
          <ListItemText>{benefit1}</ListItemText>
        </ListItemContainer>
        <ListItemContainer
          css={css`
            margin-bottom: 20px;
          `}
        >
          <BulletIcon height="13px" width="13px" />
          &nbsp;
          <ListItemText>{benefit2}</ListItemText>
        </ListItemContainer>
        <ListItemContainer>
          <BulletIcon height="13px" width="13px" />
          &nbsp;
          <ListItemText>{benefit3}</ListItemText>
        </ListItemContainer>
      </BenefitsListContainer>
      <ImgContainer className="light-bg">
        <StyledImg
          image={getImage(image?.gatsbyImageData)}
          alt={image.description}
          className={imageTint && "secondary-bg"}
        />
      </ImgContainer>
    </MobileGrid>
  );
};

MobileCourseType.propTypes = {
  index: PropTypes.number,
  margin: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
    linkText: PropTypes.string,
  }),
  benefit1: PropTypes.string,
  benefits2: PropTypes.string,
  benefits3: PropTypes.string,
  image: PropTypes.shape({
    fluid: PropTypes.shape({
      srcSet: PropTypes.string,
      aspectRatio: PropTypes.number,
    }),
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  imageTint: PropTypes.bool,
};

export default MobileCourseType;
